import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './composants/login/login.component';
import { SignupComponent } from './composants/signup/signup.component';
import { ProfilComponent } from './composants/profil/profil.component';
import { ModifyUserComponent } from './composants/modify-user/modify-user.component';
import { ViewUserComponent } from './composants/view-user/view-user.component';
import { VerifyEmailComponent } from './composants/verify-email/verify-email.component';
import { ForgotPasswordComponent } from './composants/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './composants/reset-password/reset-password.component';
import { CompleteProfilComponent } from './composants/complete-profil/complete-profil.component';
const routes: Routes = [
{ path: 'login', component: LoginComponent,   
},
{ path: 'profil', component: ProfilComponent, 
},
{ path: 'modify-user/:id', component: ModifyUserComponent,   
},
{ path: 'change-password/:id', component: ModifyUserComponent,   
},
{ path: 'complete-profil/:id', component: CompleteProfilComponent,  
},
{ path: 'view-user/:id', component: ViewUserComponent},
{ path: 'verify-email/:token', component: VerifyEmailComponent},
{ path: 'reset-password/:token', component: ResetPasswordComponent},
{ path: 'signup', component: SignupComponent,  
},
{ path: 'login/signup', component: SignupComponent,   
},
{ path: 'login/forgot-password', component: ForgotPasswordComponent,    
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
